import React from 'react';

const BubbleButton = ( { text, value, handleOnClick } ) => {
    return (
        <button className="bubble-button shadow mb-2 mb-md-0" onClick={handleOnClick} value={value}>
            {text}
        </button>
    )
}

export default BubbleButton
